import {GestureResponderEvent, StyleProp, Text, TextStyle, TouchableOpacity, ViewStyle} from 'react-native';
import {useTheme} from '~contexts/ThemeContext';
import ModernSpinner from '~components/ModernSpinner';
import { logUIClick } from '~Utils/firebaseAnalytics';

interface Props {
  label: string;
  containerStyle?: StyleProp<ViewStyle>;
  textStyle?: TextStyle;
  isLoading?: boolean;
  onPress: (event?: GestureResponderEvent) => void;
  disabled?: boolean;
  icon?: JSX.Element;
  spinnerColor?: string;
  analyticsName?: string;
}

const Button = ({
  label,
  icon,
  containerStyle,
  textStyle,
  disabled,
  isLoading = false,
  onPress,
  spinnerColor,
  analyticsName,
}: Props) => {
  const {colors} = useTheme();

  const handlePress = (event?: GestureResponderEvent) => {
    logUIClick(analyticsName || label);
    onPress(event);
  };

  return (
    <>
      {isLoading === true ? (
        <TouchableOpacity
          disabled={true}
          style={[
            {
              paddingHorizontal: 20,
              paddingVertical: 11,
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 6,
              backgroundColor: colors.error,
            },
            containerStyle,
          ]}>
          <ModernSpinner size={20} color={spinnerColor ? spinnerColor : colors.white} variant="circular" />
        </TouchableOpacity>
      ) : (
        <TouchableOpacity
          onPress={handlePress}
          disabled={disabled}
          style={[
            {
              paddingHorizontal: 20,
              paddingVertical: 11,
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 6,
              flexDirection: 'row',
              gap: 8,
              opacity: disabled ? 0.6 : 1,
            },
            containerStyle,
          ]}>
            {icon}
          {<Text style={{fontSize: 15, lineHeight: 18, ...textStyle}}>{label}</Text>}
        </TouchableOpacity>
      )}
    </>
  );
};

export default Button;
